import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PostCustomizationsDocumentPaperRequestType,
  PostCustomizationsDocumentPaperResponseType,
} from '../types';

export const postCustomizationsDocumentPaper = async ({
  pathParams: { organisationId },
  formData,
}: PostCustomizationsDocumentPaperRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/customizations/document/paper`;

  const { data } =
    await apiAuthClient.post<PostCustomizationsDocumentPaperResponseType>(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

  return data.data;
};
